export default __webpack_public_path__ + "static/media/12.79b6d3eb.svg";